/** Short reason shown beside write controls a reviewer can see but not use. */
export const READ_ONLY_REASON = "Reviewers have view-only access";
